import { createFileRoute } from "@tanstack/react-router"

import { SiftOverviewView } from "@/features/sift/components/sift-overview-view"
import { siftOverviewQueryOptions } from "@/features/sift/hooks/use-sift"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/sift/")({
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient } }) =>
    warm(queryClient, [
      siftOverviewQueryOptions(),
    ]),
  component: SiftOverviewView,
})
